import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { templateSelectors } from '../../../store/modules/template';
import { selectVideoFormats } from '../../../store/modules/video';

import { getFormatList } from './helpers';
import { VideoRatiosProps, VideoRatioItemProps } from './types';

export const useRatioList = (props: VideoRatiosProps) => {
  const videoFormats = useSelector(selectVideoFormats);
  const initialList = getFormatList({
    ...props,
    videoFormats
  });
  const [list, setList] = useState<VideoRatioItemProps[]>(initialList);

  const currentMedia = useSelector(
    templateSelectors.selectCurrentTemplateMedia
  );

  const defaultFormat = list.find(
    format => format.name === props.defaultTarget
  ) as VideoRatioItemProps;

  useEffect(() => {
    if (!currentMedia) return;

    const newList = getFormatList({
      videoFormats,
      media: currentMedia
    });
    if (defaultFormat) newList.push(defaultFormat);

    setList(newList);
  }, [currentMedia]);

  return [list, videoFormats] as const;
};
